import { COUNTRIES, DEFAULT_COUNTRY } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { parsePhoneNumberWithError } from 'libphonenumber-js';

export const getCountryFromPhoneNumber = (phone = '', code?: Iso3166TwoDigitCountryCode) => {
  if (!phone && !code) {
    return DEFAULT_COUNTRY;
  }
  try {
    if (code) {
      return COUNTRIES.find(c => c.value === code) || DEFAULT_COUNTRY;
    }

    const phoneNumber = parsePhoneNumberWithError(phone);
    const countryCode = phoneNumber.country;
    return COUNTRIES.find(c => c.value === countryCode) || DEFAULT_COUNTRY;
  } catch (_) {
    return DEFAULT_COUNTRY;
  }
};

export const getNationalNumber = (prefix: string, value = '') => {
  if (!value) {
    return value;
  }
  return value.replace(prefix, '');
};
